import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {ResponseStatus} from "../../actions/types";
import authService from "../../services/auth.service";
import {handleLogin, handleLogOut, LoginState} from "../reducers/login-reducers";

export const loginAction = createAsyncThunk(
    'login-action',
    async (loginData: {email: string, password: string}, thunkApi) => {
        try {
            return await authService.login(loginData.email, loginData.password)
                .then((response) => {
                    return response?.data
                });
        } catch (error) {
            return thunkApi.rejectWithValue(error)
        }
    }
)

export const confirmAction = createAsyncThunk(
    'confirm-action',
    async (token: string, thunkApi) => {
        try {
            return await authService.confirmUser(token)
                .then((response) => {
                    return response?.data;
                });
        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
)

export const loginWithGoogleAccountAction = createAsyncThunk(
    'loginWithGoogleAccountAction',
    async (credentials: string | undefined, thunkApi) => {
        try {
            return await authService.loginWithGoogleAccount(credentials)
                .then(response => {
                    return response?.data;
                })
        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
)

export const loginSlice = createSlice({
    name: "login",
    initialState: {
        isLoggedIn: !!localStorage.getItem("access_token"),
        isLoading: false,
        errorMessage: '',
        userGroup: null
    } as LoginState,
    reducers: {
        logOutAction: handleLogOut,
    },
    extraReducers: (builder) => {
        builder.addCase(loginAction.pending, state => handleLogin(state, ResponseStatus.PENDING, null));
        builder.addCase(loginAction.fulfilled, (state, action) => handleLogin(state, ResponseStatus.SUCCESS, action.payload));
        builder.addCase(loginAction.rejected, (state, action) => handleLogin(state, ResponseStatus.FAIL, action.payload));
        builder.addCase(loginWithGoogleAccountAction.pending, state => handleLogin(state, ResponseStatus.PENDING, null));
        builder.addCase(loginWithGoogleAccountAction.fulfilled, (state, action) => handleLogin(state, ResponseStatus.SUCCESS, action.payload));
        builder.addCase(loginWithGoogleAccountAction.rejected, (state, action) => handleLogin(state, ResponseStatus.FAIL, action.payload));
        builder.addCase(confirmAction.fulfilled, (state, action) => state);
    }
})

export default loginSlice.reducer;
export const {logOutAction} = loginSlice.actions;
